Object.defineProperty(exports,"__esModule",{value:true});var _appsRegistry=require('../services/apps-registry');var _appsRegistry2=_interopRequireDefault(_appsRegistry);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

function appsRegistryApi(){
var _appRegistry=new _appsRegistry2.default();

var registerApp=function registerApp(_ref){var appName=_ref.appName,component=_ref.component,options=_ref.options;
return _appRegistry.registerApp({appName:appName,component:component,options:options});
};

var removeApp=function removeApp(appName){
return _appRegistry.removeApp(appName);
};

var isAppRegistered=function isAppRegistered(appName){
return _appRegistry.isAppRegistered(appName);
};

var getComponentByApp=function getComponentByApp(appName){
return _appRegistry.getComponentByApp(appName);
};

var getConfigByApp=function getConfigByApp(appName){
return _appRegistry.getConfigByApp(appName);
};

return{
registerApp:registerApp,
removeApp:removeApp,
isAppRegistered:isAppRegistered,
getComponentByApp:getComponentByApp,
getConfigByApp:getConfigByApp};

}exports.default=

appsRegistryApi();